export const limits = {
  INSIDE_SUBSIDIARY_COUNT: 5,
  OUTSIDE_SUBSIDIARY_COUNT: 5
};

export const MAX_TRADE_LICENSE_NUMBER = 12;
export const MAX_BANK_NAME_LENGTH = 50;

export const cifUpdateOptions = [
  {
    code: "Retail",
    key: "Retail",
    value: "Retail",
    label: "Retail"
  },
  {
    code: "Corporate",
    key: "Corporate",
    value: "Corporate",
    label: "Corporate"
  },
  {
    code: "Both",
    key: "Both",
    value: "Both",
    label: "Both"
  }
];

export const poaOptions = [
  {
    code: "Sole POA",
    key: "Sole POA",
    value: "Sole POA",
    label: "Sole POA"
  },
  {
    code: "Others",
    key: "Others",
    value: "Others",
    label: "Others"
  },
  {
    code: "Not applicable",
    key: "Not applicable",
    value: "Not applicable",
    label: "Not applicable"
  }
];
